// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doe-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.doe-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.doe-header h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e2a3a;
}

.doe-header p {
  margin: 0;
  color: #6b7785;
  font-size: 0.95rem;
}

.doe-card {
  background: #ffffff;
  border: 1px solid #e5e9ef;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}

.doe-card-title {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e2a3a;
}

.doe-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.doe-column {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.doe-muted {
  color: #8791a0;
  font-size: 0.8rem;
  line-height: 1.4;
}

.doe-summary-strip {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.doe-summary-strip .doe-stat {
  font-size: 0.9rem;
  color: #3d4a5c;
}

.doe-summary-strip .doe-stat strong {
  color: #1e2a3a;
}

.doe-narrative-panel {
  margin-top: 1rem;
  border: 1px solid #e5e9ef;
  border-radius: 10px;
  background: #fbfcfe;
  padding: 1.5rem 1.75rem;
}

.doe-narrative-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.doe-narrative-badge {
  margin-right: auto;
  font-size: 0.75rem;
  font-weight: 600;
  color: #5b6b81;
  background: #eef1f6;
  border-radius: 999px;
  padding: 0.25rem 0.65rem;
}

.doe-narrative {
  /* This app's global .App rule sets text-align: center (CRA boilerplate
     left over from the initial project scaffold) -- override it explicitly
     rather than relying on nothing else setting it. */
  text-align: left;
  line-height: 1.7;
  font-size: 0.97rem;
  color: #263041;
}

.doe-narrative > *:first-child {
  margin-top: 0;
}

.doe-narrative h1 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e2a3a;
  margin: 1.75rem 0 0.75rem;
}

.doe-narrative h2 {
  font-size: 1.08rem;
  font-weight: 700;
  color: #16324f;
  margin: 2.1rem 0 0.8rem;
  padding-bottom: 0.45rem;
  border-bottom: 2px solid #e2e8f2;
}

.doe-narrative h2:first-of-type {
  margin-top: 0;
}

.doe-narrative h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #33465c;
  margin: 1.3rem 0 0.5rem;
}

.doe-narrative p {
  margin: 0 0 0.9rem;
}

.doe-narrative ul,
.doe-narrative ol {
  margin: 0 0 0.9rem;
  padding-left: 1.4rem;
}

.doe-narrative li {
  margin-bottom: 0.4rem;
}

.doe-narrative li > ul,
.doe-narrative li > ol {
  margin-top: 0.4rem;
}

.doe-narrative strong {
  color: #0b5fa5;
  font-weight: 700;
}

.doe-narrative code {
  background: #eef1f6;
  border-radius: 4px;
  padding: 0.1rem 0.35rem;
  font-size: 0.85em;
  color: #38465a;
}

.doe-narrative blockquote {
  margin: 0.9rem 0;
  padding: 0.5rem 1rem;
  border-left: 3px solid #c9d3e0;
  color: #4b5a6c;
  background: #f2f4f8;
  border-radius: 0 6px 6px 0;
}

.doe-narrative hr {
  border: none;
  border-top: 1px solid #e5e9ef;
  margin: 1.5rem 0;
}

.doe-narrative table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.9rem 0;
  font-size: 0.9rem;
}

.doe-narrative th,
.doe-narrative td {
  border: 1px solid #e5e9ef;
  padding: 0.45rem 0.7rem;
  text-align: left;
}

.doe-narrative th {
  background: #f0f3f8;
  font-weight: 600;
}

.doe-narrative tr:nth-child(even) td {
  background: #fafbfd;
}

.doe-empty-state {
  color: #8791a0;
  font-style: italic;
  padding: 1rem 0;
}

.doe-chat {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e9ef;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.doe-chat-log {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  max-height: 480px;
  overflow-y: auto;
}

.doe-chat-msg {
  padding: 0.6rem 0.9rem;
  border-radius: 10px;
  max-width: 90%;
  line-height: 1.5;
}

.doe-chat-user {
  align-self: flex-end;
  background: #e8f0fe;
  color: #1e2a3a;
  white-space: pre-wrap;
}

.doe-chat-assistant {
  align-self: flex-start;
  background: #f7f9fb;
  border: 1px solid #e5e9ef;
}
`, "",{"version":3,"sources":["webpack://./src/DOEAnalyzer/DOEAnalyzer.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE;;sDAEoD;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".doe-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.doe-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.doe-header h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e2a3a;\n}\n\n.doe-header p {\n  margin: 0;\n  color: #6b7785;\n  font-size: 0.95rem;\n}\n\n.doe-card {\n  background: #ffffff;\n  border: 1px solid #e5e9ef;\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\n}\n\n.doe-card-title {\n  margin: 0 0 0.75rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e2a3a;\n}\n\n.doe-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.doe-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.doe-muted {\n  color: #8791a0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.doe-summary-strip {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.doe-summary-strip .doe-stat {\n  font-size: 0.9rem;\n  color: #3d4a5c;\n}\n\n.doe-summary-strip .doe-stat strong {\n  color: #1e2a3a;\n}\n\n.doe-narrative-panel {\n  margin-top: 1rem;\n  border: 1px solid #e5e9ef;\n  border-radius: 10px;\n  background: #fbfcfe;\n  padding: 1.5rem 1.75rem;\n}\n\n.doe-narrative-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.doe-narrative-badge {\n  margin-right: auto;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #5b6b81;\n  background: #eef1f6;\n  border-radius: 999px;\n  padding: 0.25rem 0.65rem;\n}\n\n.doe-narrative {\n  /* This app's global .App rule sets text-align: center (CRA boilerplate\n     left over from the initial project scaffold) -- override it explicitly\n     rather than relying on nothing else setting it. */\n  text-align: left;\n  line-height: 1.7;\n  font-size: 0.97rem;\n  color: #263041;\n}\n\n.doe-narrative > *:first-child {\n  margin-top: 0;\n}\n\n.doe-narrative h1 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #1e2a3a;\n  margin: 1.75rem 0 0.75rem;\n}\n\n.doe-narrative h2 {\n  font-size: 1.08rem;\n  font-weight: 700;\n  color: #16324f;\n  margin: 2.1rem 0 0.8rem;\n  padding-bottom: 0.45rem;\n  border-bottom: 2px solid #e2e8f2;\n}\n\n.doe-narrative h2:first-of-type {\n  margin-top: 0;\n}\n\n.doe-narrative h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #33465c;\n  margin: 1.3rem 0 0.5rem;\n}\n\n.doe-narrative p {\n  margin: 0 0 0.9rem;\n}\n\n.doe-narrative ul,\n.doe-narrative ol {\n  margin: 0 0 0.9rem;\n  padding-left: 1.4rem;\n}\n\n.doe-narrative li {\n  margin-bottom: 0.4rem;\n}\n\n.doe-narrative li > ul,\n.doe-narrative li > ol {\n  margin-top: 0.4rem;\n}\n\n.doe-narrative strong {\n  color: #0b5fa5;\n  font-weight: 700;\n}\n\n.doe-narrative code {\n  background: #eef1f6;\n  border-radius: 4px;\n  padding: 0.1rem 0.35rem;\n  font-size: 0.85em;\n  color: #38465a;\n}\n\n.doe-narrative blockquote {\n  margin: 0.9rem 0;\n  padding: 0.5rem 1rem;\n  border-left: 3px solid #c9d3e0;\n  color: #4b5a6c;\n  background: #f2f4f8;\n  border-radius: 0 6px 6px 0;\n}\n\n.doe-narrative hr {\n  border: none;\n  border-top: 1px solid #e5e9ef;\n  margin: 1.5rem 0;\n}\n\n.doe-narrative table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 0.9rem 0;\n  font-size: 0.9rem;\n}\n\n.doe-narrative th,\n.doe-narrative td {\n  border: 1px solid #e5e9ef;\n  padding: 0.45rem 0.7rem;\n  text-align: left;\n}\n\n.doe-narrative th {\n  background: #f0f3f8;\n  font-weight: 600;\n}\n\n.doe-narrative tr:nth-child(even) td {\n  background: #fafbfd;\n}\n\n.doe-empty-state {\n  color: #8791a0;\n  font-style: italic;\n  padding: 1rem 0;\n}\n\n.doe-chat {\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e9ef;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.doe-chat-log {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  max-height: 480px;\n  overflow-y: auto;\n}\n\n.doe-chat-msg {\n  padding: 0.6rem 0.9rem;\n  border-radius: 10px;\n  max-width: 90%;\n  line-height: 1.5;\n}\n\n.doe-chat-user {\n  align-self: flex-end;\n  background: #e8f0fe;\n  color: #1e2a3a;\n  white-space: pre-wrap;\n}\n\n.doe-chat-assistant {\n  align-self: flex-start;\n  background: #f7f9fb;\n  border: 1px solid #e5e9ef;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
